const TopBar = () => {
  return (
    <div className="hidden md:block bg-gradient-to-r from-blue-600 to-blue-700 text-white py-2">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center text-sm">
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <i className="ri-time-line"></i>
              <span>Chegamos em até 30 Minutos</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-24-hours-line"></i>
              <span>Atendimento 24 horas</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-bank-card-line"></i>
              <span>Parcelamos em até 10 vezes sem juros</span>
            </div>
          </div>
          <div className="text-right">
            <span>Visita técnica e orçamento grátis</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
